export const SETTING_NOTE_MESSAGES = {
	/**
	 * Message shown when changes require closing and reopening active sessions
	 */
	RESTART_ACTIVE_SESSIONS:
		'For changes to this setting to take effect, close and reopen any active sessions.',

	/**
	 * Message shown when changes require quitting and reopening Citrix Workspace app
	 */
	RESTART_WORKSPACE_APP:
		'For changes to this setting to take effect, quit and reopen Citrix Workspace app.',

	/**
	 * Message shown when a setting is disabled because it's managed by administrator
	 */
	ADMIN_MANAGED: 'This setting is configured by your administrator.',
} as const;

export type SettingNoteMessage =
	(typeof SETTING_NOTE_MESSAGES)[keyof typeof SETTING_NOTE_MESSAGES];
